export * from './VariableDetailsPlaceholder';
export { default } from './VariableDetailsPlaceholder';